import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';
import { BbSelectOption } from '../components/shared/bb-select/bb-select.component';

@Injectable()
export class BbSelectService {
	defaults: any;
	options: any;

	constructor(private translate: TranslateService) {
		const defaults = require('../components/shared/bb-select/defaults.json');

		this.options = new Array<ReplaySubject<any>>();

		Object.keys(defaults).forEach((key: string) => {
			defaults[key].forEach((option: BbSelectOption) => {
				option.label = this.translate.instant(option.label);
			});
			this.options[key] = new ReplaySubject<any>();
			this.options[key].next(defaults[key]);
		});
		this.defaults = defaults;
	}

	getOptions(preselect: string): ReplaySubject<any> {
		if (this.options.hasOwnProperty(preselect)) {
			return this.options[preselect];
		}
		this.options[preselect] = new ReplaySubject<any>();
		return this.options[preselect];
	}
}
